import { render, staticRenderFns } from "./TrialNotificationBar.vue?vue&type=template&id=7fc316ce"
import script from "./TrialNotificationBar.vue?vue&type=script&lang=js"
export * from "./TrialNotificationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc316ce')) {
      api.createRecord('7fc316ce', component.options)
    } else {
      api.reload('7fc316ce', component.options)
    }
    module.hot.accept("./TrialNotificationBar.vue?vue&type=template&id=7fc316ce", function () {
      api.rerender('7fc316ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trial-notification-bar/TrialNotificationBar.vue"
export default component.exports